import { combineReducers, configureStore } from '@reduxjs/toolkit';
import activate from 'modules/activateSlice';
import freeze from 'modules/freezeSlice';
import hardwareProducts from 'modules/hardwareProducts/hardwareSlice';
import ui from 'modules/uiSlice';
import { useDispatch, useSelector } from 'react-redux';

// TODO: turn on after we've gotten rid of callAPI middleware, because:
// https://redux.js.org/style-guide/#do-not-put-non-serializable-values-in-state-or-actions
const serializableCheck = false;

const reducer = combineReducers({
  ui,
  hardwareProducts,
  freeze,
  activate,
});

export const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck,
      // serializableCheck:
      // {
      //   ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER], //todo SzymonD: was just false before, see const serializableCheck = false; above, probably should exclude some callapi actions?
      // },
    }).concat([
      /* custom middleware */
    ]),
});

// Infer the `RootState` type from the root reducer
export type RootState = ReturnType<typeof reducer>;

// Infer the type of `store`
type AppStore = typeof store;
// Infer the `AppDispatch` type from the store itself
type AppDispatch = AppStore['dispatch'];

// type AppThunk<ThunkReturnType = void> = ThunkAction<ThunkReturnType, RootState, unknown, Action>;
// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
